import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setApplications, clearApplications } from "../../../store/actions/applicationActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getApplications = (bearerAuth) => {
  return async dispatch => {
    API.get(`/api/portal/application`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setApplications(response.body));
        } else if (response.status === 401) {
          dispatch(clearApplications);
          dispatch(authLogout);
        } else {
          dispatch(clearApplications)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Application Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearApplications);
      })
  }
}